function load(component) {
  return () => import(`@/views/onboarding/${component}.vue`);
}

const baseMeta = {
  layout: 'OnboardingLayout',
  requiresOnboardingSession: true,
};

export default [
  {
    path: 'onboarding',
    redirect: { name: 'onboarding:welcome' },
  },
  {
    path: 'onboarding/welcome',
    name: 'onboarding:welcome',
    component: load('OnboardingWelcomePage'),
    meta: {
      ...baseMeta,
      onboardingStep: 0,
    },
  },
  {
    path: 'onboarding/company',
    name: 'onboarding:company',
    component: load('CompanyStepPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 1,
    },
  },
  {
    path: 'onboarding/bank',
    name: 'onboarding:bank',
    component: load('BankStepPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 2,
    },
  },
  {
    path: 'onboarding/points',
    name: 'onboarding:points',
    component: load('PointsStepPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 3,
    },
  },
  {
    path: 'onboarding/tariff',
    name: 'onboarding:tariff',
    component: load('TariffStepPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 4,
    },
  },
  {
    path: 'onboarding/documents',
    name: 'onboarding:documents',
    component: load('DocumentsStepPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 5,
    },
  },
  {
    path: 'onboarding/review',
    name: 'onboarding:review',
    component: load('OnboardingReviewPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 6,
    },
  },
  {
    path: 'onboarding/success',
    name: 'onboarding:success',
    component: load('OnboardingSuccessPage'),
    meta: {
      ...baseMeta,
      onboardingStep: 7,
    },
  },
];
